import "./ListingLayoutTwo.css";

const ListingLayoutTwo = ({
  paginatedData,
  numPostsToShow,
  showImgToggler,
  showPostTitle,
  showMeta,
  showContent,
  contentType,
  truncateContent,
  wordsLimit,
  imageUrl,
  valueForWidth,
  widthPercentage,
  widthController,
  ImgWidth,
  height,
  rowGap,
  ReadMoreBgColor,
  showReadMoreToggler,
  ReadMoreTextColor,
  button_Top_bottom_Padding,
  button_Right_Left_Padding,
  title_font_size,
  Meta_font_size,
  Content_font_size,
  Read_more_font_size,
  customCSS,
  Content_Manage_styling,
  Meta_Manage_styling,
  title_Manage_styling,
  ReadMoreText,
  __, // Placeholder for translation function
}) => {
  const Listing = paginatedData.slice(0, numPostsToShow);

  return (
    <div className="wep-root">
      <div className="listing-layout" style={{ gap: rowGap }}>
        {/* Inject custom CSS when Apply button is clicked */}
        {customCSS && <style>{customCSS}</style>}
        {Listing.map((item) => {
          const formattedDate = new Date(item?.date).toLocaleDateString(
            "en-US",
            {
              year: "numeric",
              month: "long",
              day: "numeric",
            }
          );

          let featuredImgExist = false;
          if (item.hasOwnProperty("featured_image_url")) {
            const featuredImageUrlObj = item.featured_image_url;
            if (
              featuredImageUrlObj &&
              typeof featuredImageUrlObj === "object" &&
              Object.keys(featuredImageUrlObj).length > 0
            ) {
              featuredImgExist = true;
            }
          }

          return (
            <div key={item.id} className="wep-card wep-card-horizontal">
              {showImgToggler &&
                item?.featured_image_url &&
                featuredImgExist && (
                  <div className="wep-card-img">
                    <img
                      src={item.featured_image_url[imageUrl]}
                      style={{
                        ...(valueForWidth
                          ? {
                              maxWidth: widthPercentage,
                              maxHeight: widthPercentage,
                            }
                          : {
                              maxWidth:
                                widthController === true ? ImgWidth : "",
                              maxHeight: widthController === true ? height : "",
                            }),
                      }}
                      alt={item.title.rendered} // Added alt text for accessibility
                    />
                  </div>
                )}
              <div className="wep-card-body">
                <div className="wep-card-heading">
                  {showPostTitle && (
                    <h4
                      className="wep-card-title"
                      style={{
                        ...(title_Manage_styling && {
                          fontSize: title_font_size,
                        }),
                      }}
                    >
                      <a
                        href={item.link}
                        dangerouslySetInnerHTML={{
                          __html: item?.title.rendered,
                        }}
                      ></a>
                    </h4>
                  )}

                  {showMeta && (
                    <div
                      className="meta-data"
                      style={{
                        ...(Meta_Manage_styling && {
                          fontSize: Meta_font_size,
                        }),
                      }}
                    >
                      {formattedDate && `${formattedDate} `}
                      {item.post_author && `| Author: ${item.post_author} `}
                      {item.assigned_categories &&
                        `| Categories: ${item.assigned_categories} `}
                    </div>
                  )}
                </div>

                {showContent && (
                  <div
                    style={{
                      ...(Content_Manage_styling && {
                        fontSize: Content_font_size,
                      }),
                    }}
                    className="wep-card-text"
                    dangerouslySetInnerHTML={{
                      __html:
                        contentType === "Full-Post"
                          ? item?.content?.rendered
                          : !item?.excerpt?.rendered
                          ? truncateContent(item?.content?.rendered, wordsLimit)
                          : truncateContent(
                              item?.excerpt?.rendered,
                              wordsLimit
                            ),
                    }}
                  />
                )}
              </div>

              <div className="wep-card-footer">
                <a
                  href={item.link}
                  target="_blank"
                  className="wep-btn wep-btn-primary"
                  style={{
                    ...(showReadMoreToggler && {
                      "--wep-btn-bg": ReadMoreBgColor,
                      "--wep-btn-hover-bg": `color-mix(in srgb, ${ReadMoreBgColor}, black 20%)`,
                      "--wep-btn-color": ReadMoreTextColor,
                      "--wep-btn-hover-color": ReadMoreTextColor,
                      "--wep-btn-padding-y": button_Top_bottom_Padding,
                      "--wep-btn-padding-x": button_Right_Left_Padding,
                      "--wep-btn-font-size": Read_more_font_size,
                    }),
                  }}
                >
                  {__(ReadMoreText || 'Read More', "advanced-posts-listing")}
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListingLayoutTwo;
